import React from "react";

export const backButtonValue = (
	<>
		<i className="vMid ib arrow_left edel-icon-arrow-left vTextTop" />
		<span className="vBtm ib ">Back</span>
	</>
);
